import React, { Component } from 'react'
import {InputItem, Button, Toast, Icon, Checkbox} from 'antd-mobile';
import {parseSearchToState} from '../../util/util';
import { Http, urls } from '../../api/index'
import storage from 'store'
import './login.scss';

let timer;
let timerOut;
class LoginPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      phone: '',
      code: '',
      codeBool: false,
      select: false,
      text: '获取验证码',
      time: 60,
      license: false
    }
    this.param = parseSearchToState(this.props.history.location.search) || {}
  }

  componentDidMount() {}

  componentWillUnmount() {
    clearTimeout(timerOut)
  }

  onChangePhone(phone) {
    this.setState({
      phone,
      select: phone.length === 11 && !this.state.codeBool
    })
  }

  getCode() {
    let url = urls.msgCode;
    let reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
    if (!reg.test(this.state.phone)) {
      return Toast.info('请输入正确手机号码', 1, null, false)
    }
    let data = {
      phone: this.state.phone,
      type: 1,
    };
    Http.post({ url, data }).then(res => {
      Toast.info('发送成功', 1, null, false);
      this.buttonControl();
    })
  }

  buttonControl() {
    this.setState({
      codeBool: true,
      select: false
    })
    timer = setInterval(() => {
      let time = this.state.time - 1
      this.setState({
        time
      })
    }, 1000)
    timerOut = setTimeout(() => {
      this.setState({
        codeBool: false,
        select: true,
        time: 60
      })
      clearInterval(timer);
    }, 1000 * 60)
  }

  login() {
    let url = urls.login;
    let reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
    if (!reg.test(this.state.phone)) {
      return Toast.info('请输入正确手机号码', 1, null, false)
    }
    if (!/^[0-9]{4,6}$/.test(this.state.code)) {
      return Toast.info('请输入验证码', 1, null, false)
    }
    if (!this.state.license) {
        return Toast.info('请先阅读并勾选“首汽租车服务协议“', 1, null, false);
    }
    let data = {
      phone: this.state.phone,
      code: this.state.code,
    };
    Http.post({ url, data }).then(res => {
      storage.set('user', res.data)
      Toast.info('登录成功', 1, null, true)
      this.param.type === 'refresh' ?   window.location.replace(document.referrer) : this.props.history.goBack()
    
    })
  }

  goPage() {
      this.props.history.push({
          pathname: '/webview',
          query: {url: 'https://h5.izuche.com/h5/serviceAgreement.html', title: '首汽租车服务协议'}
      });
  }

  render() {
    return <div id='login' className="content">
    <div className='close' 
      onClick={()=>{this.props.history.goBack()}}>
        <Icon type="left" color='#666' size={'md'} />
    </div>
    <div className="logo">
      <img alt='' style={{display: 'none'}} src="/assets/login.png" onClick={() => {return false}}/>
    </div>
   <div className="form">
      <div>
        <InputItem
        prefixListCls="input_phone"
        type='number'
        maxLength={11}
        value={this.state.phone}
        placeholder="请输入手机号"
        onChange={(phone)=>this.onChangePhone(phone)}
        clear
       />
      </div>
      <div className="line mt5 mb5"></div>
      <div className="code-wrap">
        <InputItem
          prefixListCls="input_code"
          type='number'
          maxLength={6}
          value={this.state.code}
          placeholder="请输入验证码"
          onChange={(code)=> this.setState({code}) }
          clear={true}
          />
        <Button 
          onClick={()=>this.getCode()}  
          size="small" 
          className="bth" 
          type="warning" 
          plain="{{!select}}" 
          disabled={!this.state.select}>{this.state.codeBool?`(${this.state.time})s`:this.state.text}</Button>
      </div>
      <div className="line mt5"></div>
    </div>
    <Button 
      onClick={()=>this.login()} 
      className="mt40" 
      size="large" 
      type="warning">登录</Button>
      <p className="license checkbox-wrap">
          <Checkbox
              checked={this.state.license}
              onChange={() => {
                  this.setState({
                      license: !this.state.license
                  });
              }}>
              登录即表示您已同意<span onClick={() => this.goPage()}>《首汽租车服务协议》</span>
          </Checkbox>
      </p>
  </div>
  }
}

export default LoginPage